export const WGPTMockHeaders = {
  "x-api-environments": process.env.NEXT_PUBLIC_WGPT_X_API_ENVIRONMENTS ?? "",
  "x-message-id": process.env.NEXT_PUBLIC_WGPT_X_MESSAGE_ID ?? "",
  "x-message-id-secondary":
    process.env.NEXT_PUBLIC_WGPT_X_MESSAGE_ID_SECONDARY ?? "",
  "x-message-question-type":
    process.env.NEXT_PUBLIC_WGPT_X_MESSAGE_QUESTION_TYPE ?? "",
  "x-message-sender": process.env.NEXT_PUBLIC_WGPT_X_MESSAGE_SENDER ?? "",
  "x-session-created": process.env.NEXT_PUBLIC_WGPT_X_SESSION_CREATED ?? "",
  "x-session-id": process.env.NEXT_PUBLIC_WGPT_X_SESSION_ID ?? "",
  "x-session-participants":
    process.env.NEXT_PUBLIC_WGPT_X_SESSION_PARTICIPANTS ?? "",
  "x-test-error": process.env.NEXT_PUBLIC_WGPT_X_TEST_ERROR ?? "",
};
